
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/actuary/courses/cp321",
      function () {
        return require("private-next-pages/actuary/courses/cp321/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/actuary/courses/cp321"])
      });
    }
  